import { render } from "./RecoverPasswordView.vue?vue&type=template&id=319640da&scoped=true"
import script from "./RecoverPasswordView.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordView.vue?vue&type=script&lang=js"

import "./RecoverPasswordView.vue?vue&type=style&index=0&id=319640da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319640da"]])

export default __exports__